<template>
  <div>
    <van-overlay :show="visible" z-index="2001" :custom-style="{backgroundColor: 'rgba(0, 0, 0, .6)'}"/>
    <van-action-sheet v-model="visible" :round="false" :overlay="false" class="custom-shop-choose">
      <a href="javascript:;" class="btn-close" @click="handleClose"></a>
      <div class="title">
        <img class="icon" src="../assets/icons/index_menu5_cur.png" alt="">
        <span>{{title}}</span>
      </div>
      <div class="option-box">
        <ul>
          <li class="option-item" v-for="item in columnsComputed" :key="item.Value" @click="handleChange(item)">{{item.Text}}</li>
        </ul>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>

export default {
  name: 'CustomPicker',

  props: {
    visible: Boolean,
    title: {
      type: String,
      default: ''
    },
    columns: Array
  },

  computed: {
    columnsComputed () {
      return this.columns
    }
  },

  methods: {
    handleClose () {
      this.$emit('update:visible', false)
    },
    handleChange (val) {
      this.handleClose()
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="less" scoped>
.custom-shop-choose {
  border-top: 10px solid #febc10;
  padding: 0 0 30px;
  box-sizing: border-box;
  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    width: 60px;
    height: 60px;
    border-bottom-left-radius: 10px;
    background: #febc10 url('../assets/icons/icon_close.png') center center no-repeat;
    background-size: 34px auto;
  }
  .title {
    display: flex;
    align-items: center;
    height: 122px;
    padding: 8px 42px 0;
    font-size: 28px;
    color: #1174b8;
    .icon {
      flex: none;
      width: 50px;
      margin-right: 10px;
    }
  }
  .option-box {
    max-height: 428px;
    box-sizing: border-box;
    padding: 0 42px;
    overflow-y: auto;
  }
  .option-item {
    border-top: 1Px solid #ccc;
    font-size: 28px;
    color: #666;
    line-height: 106px;
  }
}
</style>
